import { render, staticRenderFns } from "./ShortcomingCreate.vue?vue&type=template&id=3f25ad3d"
import script from "./ShortcomingCreate.vue?vue&type=script&lang=js"
export * from "./ShortcomingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports